<div style="padding: 16px">
  @if (lataa) {
    <div>
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div>
      @if (uusin) {
        <div style="font-size: 12px; color: #666; margin-bottom: 8px">
          Aktiivinen versio: <strong>v{{ uusin.versio }}</strong> — päivitetty {{ uusin.paivitetty | date: 'dd.MM.yyyy HH:mm' }}
          @if (uusin.paivittajaUid) {
            <span> ({{ annaPaivittajanNimi(uusin.paivittajaUid) }})</span>
          }
        </div>
      }

      <p style="font-size: 12px; color: #666; margin: 4px 0 8px 0">Mallin vastauksen rakenne on kovakoodattu palveluun ja lisätään promptiin automaattisesti — kirjoita tähän vain ohjeistus, älä vastausmuotoa.</p>

      <mat-form-field style="width: 100%">
        <mat-label>Kategorian "{{ kategoria }}" prompti</mat-label>
        <textarea matInput [formField]="muokattuKentta" style="font-family: monospace; font-size: 12px; min-height: 200px; resize: vertical"></textarea>
      </mat-form-field>

      <div style="margin-bottom: 12px">
        <div style="font-size: 12px; color: #666; margin-bottom: 6px">Tilisarjat — LLM:lle välitetään tilit, joiden 4 ensimmäistä numeroa osuvat johonkin sarjaan (sis. alitilit). Yksi tili: aseta alku = loppu. Ei sarjoja = koko tilikartta käytössä.</div>
        @for (kentat of rajaKentat; track $index) {
          <div style="display: flex; gap: 12px; align-items: center; margin-bottom: 8px; flex-wrap: wrap">
            <mat-form-field style="width: 140px">
              <mat-label>Alkaa</mat-label>
              <input matInput type="number" step="1" [formField]="kentat.alkaa" />
            </mat-form-field>
            <span style="align-self: center">–</span>
            <mat-form-field style="width: 140px">
              <mat-label>Loppuu</mat-label>
              <input matInput type="number" step="1" [formField]="kentat.loppuu" />
            </mat-form-field>
            <app-icon-button (click)="poistaRaja($index)" matIcon="delete" matTooltip="Poista sarja" actionId="Poista tilisarja"></app-icon-button>
            @if (rajaVirheellinen($index)) {
              <span style="color: #c00; align-self: center; font-size: 12px">Anna 0–9999 ja varmista että alkaa ≤ loppuu</span>
            }
          </div>
        }
        <app-button (click)="lisaaRaja()" matIcon="add" actionId="Lisää tilisarja">Lisää tilisarja</app-button>
      </div>

      <div style="display: flex; gap: 8px">
        <app-primary-button (click)="tallenna.emit()" [disabled]="tallennetaan || rajatVirheellisia" actionId="Tallenna uusi promptversio">
          @if (tallennetaan) {
            <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          Tallenna uusi versio
        </app-primary-button>
        <app-button (click)="toggleHistoria.emit()" [matIcon]="naytaHistoria ? 'expand_less' : 'expand_more'" actionId="Näytä/piilota versiohistoria">Versiohistoria</app-button>
      </div>

      @if (naytaHistoria) {
        <div style="margin-top: 16px">
          @if (historia.length > 1) {
            <table style="width: 100%; font-size: 12px; border-collapse: collapse">
              <tr style="background: #f5f5f5">
                <th style="text-align: left; padding: 6px">Versio</th>
                <th style="text-align: left; padding: 6px">Päivitetty</th>
                <th style="text-align: left; padding: 6px">Päivittäjä</th>
                <th style="text-align: left; padding: 6px">Esikatselu</th>
                <th style="padding: 6px"></th>
              </tr>
              @for (v of historia; track v.versio) {
                <tr style="border-bottom: 1px solid #eee">
                  <td style="padding: 6px; font-family: monospace">v{{ v.versio }}</td>
                  <td style="padding: 6px">{{ v.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td style="padding: 6px">{{ annaPaivittajanNimi(v.paivittajaUid) }}</td>
                  <td style="padding: 6px; max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ v.prompt | slice: 0 : 80 }}{{ v.prompt.length > 80 ? '…' : '' }}</td>
                  <td style="padding: 6px">
                    <app-button (click)="esikatsele.emit(v)" actionId="Esikatsele promptversio">Näytä</app-button>
                    <app-button (click)="palautaVersio.emit(v.versio)" actionId="Palauta promptversio">Palauta</app-button>
                  </td>
                </tr>
              }
            </table>
          } @else {
            <p style="color: #888; font-size: 12px; margin: 0">Ei aiempia versioita.</p>
          }
        </div>
      }

      @if (esikatseluVertailu) {
        <app-prompti-versiovertailu [vertailu]="esikatseluVertailu" (palauta)="palautaVersio.emit($event)" (sulje)="suljeEsikatselu.emit()"></app-prompti-versiovertailu>
      }
    </div>
  }
</div>
